// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grecaptcha-badge{visibility:hidden}.invisible-captcha-btn .g-spinner div{border-color:#fff transparent transparent transparent!important}.invisible-captcha-btn .g-spinner.-small{padding:unset!important}", ""]);
// Exports
module.exports = exports;
